export default __webpack_public_path__ + "static/media/dispatch_later_color.5045be78.svg";